import React, { useEffect, useState } from 'react';
import styles from './christmas-decor.module.css';

/**
 * Checks if the current date is within the Christmas period (Dec 1st - Dec 26th).
 */
export function isChristmasTime(): boolean {
    const now = new Date();
    const month = now.getMonth(); // 0-indexed, so 11 is December
    const day = now.getDate();

    return month === 11 && day >= 1 && day <= 26;
}

/**
 * Renders a bar of christmas lights hanging from the chat input.
 */
export const ChristmasDecor: React.FC = () => {
    const [lightCount, setLightCount] = useState(24);

    useEffect(() => {
        const updateLightCount = () => {
            // Approx one light every 40px
            const count = Math.floor(window.innerWidth / 40);
            setLightCount(Math.min(Math.max(count, 12), 60)); // Min 12, max 60
        };

        updateLightCount();
        window.addEventListener('resize', updateLightCount);
        return () => window.removeEventListener('resize', updateLightCount);
    }, []);

    // Only render between Dec 1st and Dec 26th
    if (!isChristmasTime()) {
        return null;
    }

    return (
        <div className={styles.christmasContainer} aria-hidden="true">
            <div className={styles.christmasGlow} />
            <div className={styles.lightsStrand}>
                {/* Generate a strand of lights */}
                {Array.from({ length: lightCount }).map((_, i) => (
                    <div key={i} className={styles.light} />
                ))}
            </div>
        </div>
    );
};
